import React from 'react'
import img1 from '../../assets/Images/Chart.png'
import img2 from '../../assets/Images/Table.png'
import img3 from '../../assets/Images/Detailed Statistics.png'
import img4 from '../../assets/Images/Chart-3.png'
import styled from 'styled-components'
import Tick from '../../assets/tick_mark.png'
import { useNavigate } from 'react-router-dom'

const P = styled.p`
    font-size: 14px;
`;
const Head = styled.p`
    color: #0084FF;
    font-weight: 600;
`;

const arr =[
    {
        img: img1,
        tag: "Exchange",
        head: "Buy & Sell Cryptocurrencies in P2P Marketplace",
        subhead: "No matter your level of experience with cryptocurrency, Trade Crypto globally on your own terms using over 400+ payment methods and any currency. Also, you can buy or sell gift cards for Bitcoin. ",
        points: [
            "400+ Payment methods. All fiat currencies supported",
            "Convert Crypto instantly at market price in 2 clicks.",
            "Easy, and reliable way to trade gift cards for Bitcoin",
        ],
        button_text: "Start Trading"
    },
    {
        img: img2,
        tag: "Exchange",
        head: "The Lowest Fees in the Market",
        subhead: "We offer the lowest trading fees in the market. Our fees structure is transparent to our community.",
        points: [
            "Buy Bitcoin with Zero fees",
            "Transparent fees structre"
        ],
        button_text: "Buy Bitcoin"
    },
    {
        img: img4,
        tag: "Security",
        head: "Safety First With Escrow Protection",
        subhead: "Your funds are shielded by Qvani’s escrow system, ensuring cryptocurrencies are securely held until both parties fulfill their terms.",
        points: [
            "Cutting-edge AI tools monitor transactions and identify potential fraud.",
            "Advanced computer vision models verify proof of payment.",
            "Dedicated dispute resolution team."
        ],
        button_text: "Start Trading"
    },
    {
        img: img3,
        tag: "Security",
        head: "Your assets are secure",
        subhead: "Your crypto is your crypto. It’s that simple. Qvani exchange doesn't use, or lend, your assets without your permission. ",
        points: [
            "256-bit encryption to protect your data.",
            "A battle-tested and secure infrastracture that includes hot, cold, and offline wallets.",
            "No single point of failure, as Qvani supports an independent set of checks and balances, regulation of activity, and capital reserves."
        ],
        button_text: "Get free secure Bitcoin wallet"
    },
]
export default function Experience() {
    const navigate = useNavigate();
    return (
        <div className='container-fluid mt-5'>
        {
            arr.map((data, index)=>{
                return <div className={`row m-0 d-flex ${index%2!= 0 && 'flex-row-reverse'} gap-2 gap-md-5 mt-4 justify-content-center align-items-center`}>
                    <div className='col-md-4 col-sm-6 mb-4 my-1'>
                        <p className='fs-3 fw-bold mb-2 text-center text-md-start'>{data.head}</p>
                        <P className='mb-4 text-justify'>{data.subhead}</P>
                        {
                            data?.points?.map((p)=>{
                                return <P className='mb-2'><img src={Tick} width="30px"style={{ paddingRight: "5px"}}/>{p}</P>
                            })
                        } 
                        <button onClick={()=> navigate("/signup")} className='mt-2 card-button'>{data.button_text}</button>
                    </div>
                    <div className='col-md-4 my-1'>
                        <img src={data.img} width='100%' />
                    </div>
                </div>
            })
        }
        </div>
    );
}